var _NoDate;
import React from 'react';
import { buttonClasses } from '@mui/material/Button';
import { string, oneOfType, number, bool, func, oneOf } from 'prop-types';
import { emphasize, styled } from '@mui/material/styles';
import clsx from 'clsx';
import SovosButton from '../../sovos-button';
import buttonVariants from '../utils/calendarButtonVariants';
const {
  textPrimary,
  disabled: disabledClass
} = buttonClasses;
const Root = styled(SovosButton)(_ref => {
  let {
    theme: {
      palette,
      spacing
    }
  } = _ref;
  const borderRadius = spacing(2);
  return {
    borderRadius,
    boxSizing: 'border-box',
    fontWeight: 500,
    height: spacing(4),
    marginInline: spacing(0.25),
    minWidth: spacing(4),
    padding: 0,
    transition: 'none',
    // disable Mui transitions
    ["&.".concat(textPrimary)]: {
      color: palette.text.primary,
      width: spacing(4),
      ["&.".concat(disabledClass)]: {
        color: palette.text.disabled
      },
      '&:hover': {
        backgroundColor: palette.action.hover
      }
    },
    '&:focus, &:focus-visible': {
      backgroundColor: palette.action.focus
    },
    '&.sovosMonthRangePicker__calendarButton': {
      '&--year': {
        ["&.".concat(textPrimary)]: {
          width: spacing(8.5)
        }
      },
      '&--selected': {
        ["&.".concat(textPrimary)]: {
          backgroundColor: palette.primary.main,
          color: 'white',
          '&:hover': {
            backgroundColor: palette.primary.main
          },
          '&:focus, &:focus-visible': {
            backgroundColor: palette.primary.dark
          }
        }
      },
      '&--currentMonth': {
        backgroundColor: palette.action.selected,
        '&:hover': {
          backgroundColor: emphasize(palette.action.selected, palette.action.hoverOpacity)
        }
      },
      '&--rangeStart': {
        ["&.".concat(textPrimary)]: {
          borderRadius: "".concat(borderRadius, " 0 0 ").concat(borderRadius),
          marginInlineEnd: 0,
          width: spacing(4.25)
        }
      },
      '&--rangeMiddle': {
        ["&.".concat(textPrimary)]: {
          borderRadius: 0,
          marginInlineEnd: 0,
          marginInlineStart: 0,
          width: spacing(4.5)
        }
      },
      '&--rangeEnd': {
        ["&.".concat(textPrimary)]: {
          marginInlineStart: 0,
          borderRadius: "0 ".concat(borderRadius, " ").concat(borderRadius, " 0"),
          width: spacing(4.25)
        }
      }
    }
  };
});
const NoDate = styled('span')(_ref2 => {
  let {
    theme: {
      palette,
      shape: themeShape,
      spacing
    }
  } = _ref2;
  return {
    borderRadius: themeShape.borderRadiusRound,
    boxSizing: 'border-box',
    fontWeight: 500,
    height: spacing(4),
    marginInlineStart: spacing(0.25),
    marginInlineEnd: spacing(0.25),
    minWidth: spacing(4),
    padding: 0,
    transition: 'none',
    // disable Mui transitions
    ["&.".concat(textPrimary)]: {
      color: palette.text.primary,
      width: spacing(4),
      '&:hover': {
        backgroundColor: palette.action.hover
      }
    }
  };
});
const CalendarButton = _ref3 => {
  let {
    ariaLabel,
    date,
    disabled = false,
    onClick,
    variant
  } = _ref3;
  const isSelected = [buttonVariants.rangeStart, buttonVariants.rangeEnd, buttonVariants.rangeMiddle, buttonVariants.monthSelected, buttonVariants.yearSelected].indexOf(variant) !== -1;
  const isYear = [buttonVariants.year, buttonVariants.yearSelected].indexOf(variant) !== -1;
  return date ? /*#__PURE__*/React.createElement(Root, {
    "aria-label": ariaLabel,
    className: clsx('sovosMonthRangePicker__calendarButton', isSelected && 'sovosMonthRangePicker__calendarButton--selected', isYear && 'sovosMonthRangePicker__calendarButton--year', "sovosMonthRangePicker__calendarButton--".concat(buttonVariants[variant])),
    disabled: disabled,
    disableRipple: true,
    onClick: onClick,
    variant: "text"
  }, date) : _NoDate || (_NoDate = /*#__PURE__*/React.createElement(NoDate, null));
};
CalendarButton.propTypes = {
  ariaLabel: string,
  date: oneOfType([string, number]).isRequired,
  disabled: bool,
  onClick: func.isRequired,
  variant: oneOf(Object.values(buttonVariants))
};
export default CalendarButton;